import * as React from 'react';

import type {EventForTimeline} from '../types';

import {getQuoteLinkText, getTargetEntities, makeTargetEntitiesDisplay} from './helpers';
import {TimelineBanner} from './timeline-banner';

type Props = {
    event: EventForTimeline;
};

const USER_DRIVEN_EVENTS = ['ready_time', 'sent_time', 'revoked_time'];
const ALL_EVENTS = ['ready_time', 'sent_time', 'revoked_time', 'accepted_time'];

export function TimelineBannerContract(props: Props) {
    const {event} = props;
    const {payload, changes} = event;

    const getAction = (
        attribute: string,
        documentNumber: string,
        targetEntities: React.ReactElement<any>,
        htmlUrlPath: string
    ) => {
        const documentNumberBold = getQuoteLinkText(htmlUrlPath, documentNumber);

        switch (attribute) {
            case 'ready_time':
                return (
                    <span>
                        marked document {documentNumberBold} as ready for <b>{targetEntities}</b>
                    </span>
                );
            case 'sent_time':
                return (
                    <span>
                        sent document {documentNumberBold} to <b>{targetEntities}</b>
                    </span>
                );
            case 'revoked_time':
                return (
                    <span>
                        revoked document {documentNumberBold} for <b>{targetEntities}</b>
                    </span>
                );
            case 'accepted_time':
                return (
                    <span>
                        <b>{targetEntities}</b> accepted document {documentNumberBold}
                    </span>
                );
            default:
                return <></>;
        }
    };

    if (payload.__typename === 'Contract') {
        const change = changes.find((c) => ALL_EVENTS.includes(c.attribute));

        const targetEntities = getTargetEntities(payload.lead);

        const targetEntitiesDisplay = makeTargetEntitiesDisplay(
            targetEntities,
            payload.lead.name,
            payload.lead.htmlUrl
        );

        const htmlUrlPath = payload.htmlUrlPath;
        const displayNumber = payload.displayNumber;
        const attribute = change ? change.attribute : '';

        const actor = USER_DRIVEN_EVENTS.includes(attribute) ? payload.creatorUser : null;
        const omitActor = actor === null;

        const action = getAction(attribute, displayNumber, targetEntitiesDisplay, htmlUrlPath);

        return (
            <TimelineBanner
                id={event.id}
                iconVariant='document'
                timestamp={event.changeTime}
                actor={actor}
                action={action}
                omitActor={omitActor}
            />
        );
    }

    return <></>;
}
